<script setup lang="ts">
const props = defineProps<{
	title: string
	data: { label: string; to: string }[]
}>()
</script>

<template>
	<div class="footer-links-list">
		<h6 class="footer-links-list__title">{{ props.title }}</h6>
		<!-- <div class="footer-links-list__container"> -->
		<GlobalFooterLinks :data="props.data" />
		<!-- </div> -->
	</div>
</template>

<style scoped lang="scss">
@import './LinksList';
</style>
